import { find } from 'lodash';
import { DocumentNode, OperationDefinitionNode } from 'graphql';

export const getOperationName = (queryDocument: DocumentNode): string | undefined => {
  const query = find(queryDocument.definitions, ['kind', 'OperationDefinition']) as OperationDefinitionNode
  return query.name?.value
}
